export enum AircraftUtilizationStatus {
  Offered = 1,
  Accepted = 2,
  Rejected = 3,
}
